@if (data$ | async; as data) {
<div
  class="footer-container"
  [class.footer-asm-container]="asmEnabled"
>
  <div class="footer-label" [innerHTML]="data?.label"></div>
  @if ((data?.phoneNumber | json) !== '{}') {
  <div class="footer-phone">{{ data?.phoneNumber }}</div>
  } @if ((data?.email | json) !== '{}') {
  <div class="footer-email">{{ data?.email }}</div>
  } @if (imageLinks?.length) {
  <div class="footer-links">
    @for (slide of imageLinks; track slide) {
    <div>
      <a href="{{ slide.url }}" target="_blank">
        <cx-media [container]="slide.media" removeImageTitleAttr></cx-media>
      </a>
    </div>
    }
  </div>
  }
</div>
}
